import React from 'react';

// Material ui
import { Radio as MaterialRadio, Grid } from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';

// Style
import './Radio.scss';
import { UncheckedRadio, CheckedRadio } from '@/assets/icons';

interface Props {
    checked: boolean;
    disabled?: boolean;
    value?: any;
    label?: string;
    onClick?: <T>(_arg: T) => {} | any;
    color?: 'primary' | 'secondary' | 'primary-dark';
    typographyVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'table-regular' | 'table-underline' | 'table-semibold' | 'input-head' | 'body-regular' | 'body-semibold' |'note-regular' | 'note-semibold' | 'steps';

}

const Radio: React.FC<Props> = ({
    checked,
    value,
    disabled = false,
    onClick,
    label,
    color = 'primary-dark',
    typographyVariant = 'body-regular'
}) => {

    return (
        <Grid
            container={!!label}
            alignItems={!!label ? 'center' : undefined}
            // className={`ui-Checkbox-input${className ? ` ${className}` : ''}`}
        >
            <MaterialRadio
                disableRipple
                disableFocusRipple
                disableTouchRipple
                disabled={disabled}
                checked={checked}
                value={value}
                onClick={onClick}
                icon={<UncheckedRadio />}
                checkedIcon={<CheckedRadio />}
                classes={{
                    root: 'ui-Radio-button-root-component'
                }}
            />
            { label && (
                <Typography
                    variant={typographyVariant}
                    color={color}
                >
                    {label}
                </Typography>
            )}
        </Grid>
    );
};

export default Radio;